// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__2t1os","resendInfoText":"OnGoingPaymentBox_resendInfoText__PJDPQ"};